import { alertClasses } from "@mui/material";
import type { Components, Theme } from "@mui/material/styles";

/**
 * MUI v9 Alert colors come from `palette.Alert` CSS variables (e.g. warningFilledBg).
 * See `buildPaletteAlert` in theme/alertPalette.ts and palette.light/dark.ts.
 * Icon inherits text color so custom FilledColor / Color tokens apply consistently.
 */
export const MuiAlert: Components<Theme>["MuiAlert"] = {
  styleOverrides: {
    root: {
      [`& .${alertClasses.icon}`]: {
        color: "inherit",
      },
    },
  },
};
